import { action, makeObservable, observable, reaction } from 'mobx';
import { UiStore } from './ui';
import { appConfig } from '../settings';
import { IFilterParams, IInvoice, IInvoicesList } from '../interfaces';
import { getInvoicesList } from '../middleware';
import { apiParamsCleaner } from '../instruments';

const defaultItem: IInvoice = { id: 0 };

export class InvoicesStore {
    private constructor() {
        makeObservable(this);
        reaction(
            () => this.forcedUpdateTime,
            () => {
                const UiStoreInstance = UiStore.getInstance();
                const params = UiStoreInstance.params;
                const cleanParams = apiParamsCleaner(params, this.filterParams);
                getInvoicesList(cleanParams).then();
            },
            {
                delay: appConfig.APIDelay,
            },
        );
    }

    private static instance: InvoicesStore;
    public static getInstance(): InvoicesStore {
        if (!InvoicesStore.instance) {
            InvoicesStore.instance = new InvoicesStore();
        }
        return InvoicesStore.instance;
    }

    @observable item: IInvoice = defaultItem;
    @action setItem(item: IInvoice): void {
        this.item = item;
    }

    @observable list: IInvoicesList = [];
    @action setList(list: IInvoicesList): void {
        this.list = list;
    }

    @observable forcedUpdateTime = 0;
    @action setForcedUpdateTime(): void {
        this.forcedUpdateTime = Date.now();
    }

    @observable filterParams: IFilterParams = {
        pageNumber: true,
        pageSize: true,
        search: true,
        dateRange: true,
        buyerId: true,
        sellerId: true,
    };

    @action cleanItem(): void {
        this.item = defaultItem;
    }

    @action cleanStore(): void {
        this.list = [];
    }
}
